// 项目APPID
export const APPID = "portal";

// 后台服务地址
export const API_URL = import.meta.env.VITE_API_URL as string;
// 协议地址
export const PROTOCOL_URL = import.meta.env.VITE_PROTOCOL_URL as string;
// 小程序服务地址
export const APPLET_URL = import.meta.env.VITE_APPLET_URL as string;
// 上传文件地址
export const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL as string;

// 登陆页网址
export const LOGIN_HOST = import.meta.env.VITE_LOGIN_URL as string;

// 登陆页地址
export const LOGIN_URL = `${LOGIN_HOST}?appId=${APPID}`;
// 登录服务地址
export const LOGIN_API_URL = LOGIN_HOST || "";
// 注册页地址
export const REGISTER_URL_BASE = `${LOGIN_HOST}/register`;
// 注册页地址
export const REGISTER_URL = `${LOGIN_HOST}/register?appId=${APPID}`;

// 法搜网址
export const DATA_URL = import.meta.env.VITE_DATA_URL as string;

// 律助网址
export const DLS_URL = import.meta.env.VITE_DLS_URL as string;

// 开放平台网址
export const OPEN_URL = import.meta.env.VITE_OPEN_URL as string;

//H5网址
export const H5_URL = import.meta.env.VITE_H5_URL as string;

// TIM SDKAppID
export const TIM_APP_ID = import.meta.env.VITE_TIM_APP_ID as string;

// TIM secretKey
export const TIM_SECRET_KEY = import.meta.env.VITE_TIM_SECRET_KEY as string;

// 媒体文件 CDN 地址
export const CDN_URL_MEDIA = import.meta.env.VITE_CDN_URL_MEDIA as string;
export const CDN_URL_GIF = import.meta.env.VITE_CDN_URL_GIF as string;
export const CDN_URL_VIDEO = import.meta.env.VITE_CDN_URL_VIDEO as string;
/**
 * 微信公众号appId
 */
export const WX_H5_APPID = import.meta.env.VITE_H5_WX_LOGIN_APPID;

export const WPS_APP_ID = import.meta.env.VITE_WPS_APP_ID;

// 不同环境跳转的URL列表
export const URL_LIST = {
  login: `${DLS_URL}/user/login`, // 登录
  buyLogin: `${DLS_URL}/user/login`, // 立即购买登录
  register: `${DLS_URL}/user/register`, // 注册
  account: `${DLS_URL}/web/account/index`, //个人中心
  Dls: DLS_URL, // 数字化中心
  DlsData: `${DLS_URL}/web/lawSearch/home`, // 法搜
  DlsOffice: `${DLS_URL}/web/customer/list`, // 法秘
  DlsNews: `${DLS_URL}/web/subscription/index?type=3`, // 法讯
  DlsAnswers: `${DLS_URL}/web/lawSearch/lawQuestion`, //法问
  legalSearch: DATA_URL, //得理法搜
  lSearchQuestion: `${DATA_URL}/lawQuestion`, //得理法搜法问
  registerDATA: `${DATA_URL}/register`, //注册完重定向法搜
};

//律助APP下载地址
export const DLS_DOWNLOAD_URL = "https://dls.delilegal.com/app/download";
//法搜APP下载地址
export const DATA_DOWNLOAD_URL = "https://data.delilegal.com/app/other/appDownload";

// openinstall 法搜
export const OPEN_INSTALL_APP_KEY = "e31j9t";

//Iconfont图标URL
export const ICON_FONT_SCRIPT_URL =
  "https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/svg_34878_742.51cfe9354ebda176a0ffc8106b67fda6.js";

export const ali_captcha_appkey = import.meta.env.VITE_ALI_CAPTCHA_APP_KEY;
export const ali_captcha_scene = import.meta.env.VITE_ALI_CAPTCHA_SCENE;
